"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const AddToWishlist = (0, graphql_tag_1.default) `
  mutation addToWishlist(
    $variationId: String!
    $name: String
    $price: Float
    $userId: String!
  ) {
    addToWishlist(
      wishlistRequest: {
        userId: $userId
        product: { id: $variationId, name: $name, price: $price }
      }
    ) {
      status
      item {
        id
        name
        price
        createdAt
      }
    }
  }
`;
exports.default = AddToWishlist;
